import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CanvasComponent } from "./canvas/canvas.component";

const routes: Routes = [{ path: "draw", component: CanvasComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AnnotationRoutingModule {}
